import React from "react";

const Footer = () => {
  return (
    <div style={{ textAlign: "center", marginBottom: "10", padding: "10px" }}>
      Made by{" "}
      <a style={{ cursor: "pointer" }} href="https://github.com/ahmadswalih">
        <span style={{ color: "green" }}> Ahmad swalih </span>
      </a>
    </div>
  );
};

export default Footer;
